import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

const importSchedule = (file: any) => {
  const formData = new FormData();
  formData.append('file', file);

  return http('multipart').post(endpoints.scheduling.importSchedule, formData);
};

export function useImportSchedule() {
  return useMutation({ mutationFn: importSchedule });
}
